import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box, Typography } from '@mui/material';

import { AccountClientHistory } from './clientHistory';
import { AccountDetailGeneralInfo } from './generalInfo';
import { AccountHabeasDataHistory } from './habeasDataHistory';
import { AccountRegisterHistory } from './registerHistory';
import { useAccountDetail } from './hook';
import { AccountHistorical } from '../historical';

import { AccountRegisterCasePqr } from './casePqr';
import { AccountRegisterCaseSarlaft } from './caseSarlaft';
import { AccountRegisterCasesGeneralInformationForm } from './casesGeneralInformationForm';
import { AccountRegisterSwitchForm } from './switchForm';
import { AccountRegisterCaseGeneral } from './caseGeneral';
import { AccountRegisterQuotationForm } from './quotationForm';

import { LayoutModule } from '../../../../layout/modules';
import { TitleV1 } from '../../../../components/titleV1';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { Dialog } from '../../../../components/general/dialog/dialog';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';

import {
    ACCOUNTS,
    ACCOUNTS_NEW,
    ACCOUNTS_EDIT,
} from '../../../../../routes/paths';
import { SkillBpEnum } from '../../../../../shared/types/shared';
import { InteractionHistory } from './interactionHistory';

export const AccountDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        account,
        loading,
        accountHistorical,
        skill,
        accountOutdated,
        setAccountOutdated,
    } = useAccountDetail(showHistorical);
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = account && account?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle cuenta"
                titleChildren="INFORMACIÓN GENERAL - PERSONA DE CONTACTO"
                additionalButtons={
                    <ActionButtonGroup
                        id={account?.id || ''}
                        buttonCreate={{
                            show: showActionButtons && !isOnlyViewProfile(type),
                            route: ACCOUNTS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: ACCOUNTS,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: ACCOUNTS_EDIT,
                        }}
                        buttonView={{
                            show: false,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <AccountHistorical
                            historical={accountHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                {accountOutdated && (
                    <Dialog
                        title="Cuenta desactualizada"
                        open={accountOutdated}
                        onClose={() => setAccountOutdated(false)}
                        maxWidth="md"
                    >
                        <Typography>
                            <p>
                                Se requiere actualización de datos de la cuenta,
                                <br />
                                Le invitamos a actualizarlos para mantener su
                                información segura y al día.
                            </p>
                        </Typography>
                    </Dialog>
                )}
                <AccountDetailGeneralInfo account={account} loading={loading} />
            </LayoutModule>
            <AccountHabeasDataHistory />
            <AccountClientHistory />
            <InteractionHistory account={account} />
            <AccountRegisterHistory account={account} />
            {!isOnlyViewProfile(type) && (
                <>
                    <TitleV1 title="REGISTRO DE CASOS" />
                    {!isSupervisor(type) && (
                        <AccountRegisterCasesGeneralInformationForm
                            isOpen={skill === SkillBpEnum.INFORMACION_GENERAL}
                            account={account}
                        />
                    )}
                    {!isSupervisor(type) && (
                        <AccountRegisterSwitchForm
                            isOpen={skill === SkillBpEnum.CONMUTADOR}
                        />
                    )}
                    {process.env.REACT_APP_PQR_RADICATION_ENABLED === 'true' && (
                        <AccountRegisterCasePqr account={account} />
                    )}
                    {!isSupervisor(type) && (
                        <>
                            <AccountRegisterCaseSarlaft
                                account={account}
                                isOpen={skill === SkillBpEnum.SARLAFT}
                            />
                            <AccountRegisterCaseGeneral />
                        </>
                    )}
                    {!isSupervisor(type) && <AccountRegisterQuotationForm />}
                </>
            )}
        </>
    );
};
